import React from 'react';

import { Spacer } from '@/components/common';
import { Skeleton } from '@/components/memo';

import './RequestPlaceholder.css';

const RequestPlaceholder: React.FC = () => {
  return (
    <div className="request-item">
      <div className="request-item__details">
        <div className="request-item__patient">
          <Skeleton className="request-placeholder__patient-name-skeleton" />
          <Skeleton className="request-placeholder__patient-gender-skeleton" />
        </div>
        <Spacer top={2} bottom={12}>
          <Skeleton className="request-placeholder__purpose-skeleton" />
        </Spacer>
        <div className="request-item__schedule">
          <div>
            <Skeleton className="request-placeholder__icon-skeleton" />
            <Skeleton className="request-placeholder__date-skeleton" />
          </div>
          <div>
            <Skeleton className="request-placeholder__icon-skeleton" />
            <Skeleton className="request-placeholder__time-skeleton" />
          </div>
          <div>
            <Skeleton className="request-placeholder__icon-skeleton" />
            <Skeleton className="request-placeholder__mobile-number-skeleton" />
          </div>
        </div>
      </div>
      <Spacer bottom={-8}>
        <div className="request-item__actions">
          <Skeleton className="request-placeholder__action-button-skeleton" />
          <div className="request-placeholder__sub-button-container">
            <Skeleton className="request-placeholder__action-button-skeleton" />
          </div>
        </div>
      </Spacer>
    </div>
  );
};

export default RequestPlaceholder;
